// ===========================================
// SinistresList — Sinistres en cours (statut declare ou en_cours)
// ===========================================
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Empty, Skeleton, Tag, Button } from 'antd';
import { WarningOutlined, EyeOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { formatDate } from '../../../common/utils/format';
import { SINISTRE_STATUTS } from '../../../common/constants/statuts';

const getClientLabel = (client) => {
    if (!client) return '—';
    if (client.raisonSociale) return client.raisonSociale;
    return `${client.prenom || ''} ${client.nom || ''}`.trim() || client.code || '—';
};

const StatusTag = ({ statut }) => {
    const cfg = SINISTRE_STATUTS[statut] || { color: 'default', label: statut };
    return <Tag color={cfg.color}>{cfg.label}</Tag>;
};

const SinistreItem = ({ sinistre }) => {
    const navigate = useNavigate();
    const clientLabel = getClientLabel(sinistre.client);
    const typeLabel = sinistre.contrat?.typeAssurance?.nom || sinistre.typeSinistre || '—';
    const dateStr = formatDate(sinistre.dateSinistre || sinistre.dateDeclaration);

    return (
        <li className="op-list-item">
            <div className="op-list-item-main">
                <div className="op-list-item-title">{clientLabel}</div>
                <div className="op-list-item-meta">
                    <Tag>{typeLabel}</Tag>
                    {sinistre.numero && (
                        <span className="op-list-item-numero">{sinistre.numero}</span>
                    )}
                </div>
            </div>
            <div className="op-list-item-mid">
                <div className="op-list-item-date">{dateStr}</div>
                <StatusTag statut={sinistre.statut} />
            </div>
            <div className="op-list-item-actions">
                <Button
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => navigate(`/dashboard/sinistre/${sinistre._id}`)}
                    aria-label="Voir détail"
                />
            </div>
        </li>
    );
};

const SinistresList = ({ data, loading }) => {
    return (
        <Card
            className="dashboard-op-card"
            title={
                <div className="chart-card-title">
                    <WarningOutlined />
                    <span>Sinistres en cours</span>
                    {data?.length > 0 && <span className="op-card-count">{data.length}</span>}
                </div>
            }
        >
            <div className="op-list-wrapper">
                {loading ? (
                    <Skeleton active paragraph={{ rows: 4 }} />
                ) : !data || data.length === 0 ? (
                    <Empty
                        description={
                            <span>
                                <CheckCircleOutlined style={{ color: '#16a34a', marginRight: 6 }} />
                                Aucun sinistre en cours
                            </span>
                        }
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        className="op-empty"
                    />
                ) : (
                    <ul className="op-list">
                        {data.slice(0, 8).map((s) => (
                            <SinistreItem key={s._id} sinistre={s} />
                        ))}
                    </ul>
                )}
            </div>
        </Card>
    );
};

export default SinistresList;
